import GroupController from "./group_controller"
import {TimeZoneGroupValidatorStrategy} from "../util/GroupValidatorStrategy"

export default function TimeZoneGroupController() {}

TimeZoneGroupController.prototype = new GroupController();

TimeZoneGroupController.prototype.init = function(config)
{
    GroupController.prototype.init.call(this, config);
    this.selectorIdPrefix = config.selectorIdPrefix;
    this.groupNamingKey = "common.time_zone_group";
    this.GroupNamingKey = "common.Time_Zone_Group";
    return this;
};

TimeZoneGroupController.prototype.createGroupRow = function(group, controller)
{
    return new TimeZoneGroupRow().init(
            document.getElementById(formatId(this.groupDivIdPrefix, group.id)),
            document.getElementById(formatId(this.groupDeleteLinkIdPrefix, group.id)),
            document.getElementById(formatId(this.undoDeleteIdPrefix, group.id)),
            document.getElementById(formatId(this.acceptDeleteIdPrefix, group.id)),
            document.getElementById(formatId(this.undoEditIdPrefix, group.id)),
            document.getElementById(formatId(this.acceptEditIdPrefix, group.id)),
            document.getElementById(formatId(this.editInputIdPrefix, group.id)),
            document.getElementById(formatId(this.nameCellIdPrefix, group.id)),
            document.getElementById(formatId(this.inputCellIdPrefix, group.id)),
            document.getElementById(formatId(this.editGroupCellIdPrefix, group.id)),
            document.getElementById(formatId(this.waitingAnimationCellIdPrefix, group.id)),
            group, new TimeZoneGroupValidatorStrategy(), controller, formatId(this.selectorIdPrefix, group.id)
    );
};

TimeZoneGroupController.prototype.getGroupData = function(group, name)
{
    return {
        id: group.id,
        name: name,
        cityPlaceId: group.cityPlaceId,
        cityName: group.cityName,
        timeZoneId: group.timeZoneId,
        rawOffset: group.rawOffset,
        currentTime: group.currentTime
    }
};

TimeZoneGroupController.prototype.cleanup = function()
{
    GroupController.prototype.cleanup.call(this);
    for (var groupId in this.groups)
        if (this.groups.hasOwnProperty(groupId))
            this.groups[groupId].cleanup();
};


// WEBPACK FOOTER //
// ./web/js/groupManagement/time_zone_group_controller.js